import footer from './footer.json';
import welcome from './welcome.json';
import tools from './tools.json';
import header from './header.json';
import main from './main.json';
import sidebar from './sidebar.json';
import deposit from './deposit.json';
import profile from './profile.json';
import partner from './partner.json';
import transactions from './transactions.json';
import support from './support.json';
import status from './status.json';
import news from './news.json';
import eclipseDrive from './eclipseDrive.json';

export const en = {
  footer,
  welcome,
  tools,
  header,
  main,
  sidebar,
  deposit,
  profile,
  partner,
  transactions,
  support,
  status,
  news,
  eclipseDrive,
};
